import logoWhite from 'src/assets/arcadis-logo-white.svg'
import logoBlack from 'src/assets/arcadis-logo-black.svg'
import logoNexus from 'src/assets/nexus-logo.png'

/**
 * Per-product branding for the app shell, selected by hostname.
 *
 * The public marketing pages that used to live in this app (and carried their
 * own `layout` / `page` / `homeTitle` here) are now served by the Astro site in
 * src/home at '/' - see docs/developer/marketing-site.md. What remains is the
 * branding the authenticated app at /app/ needs: the window title and the logo.
 */
interface CustomPageMeta {
  hostNamePrefixes: string[]
  title: string
  logo: {
    light: string
    dark: string
    width: number
  }
}

export const customPageMeta: CustomPageMeta[] = [
  {
    hostNamePrefixes: ['digitaltwins'],
    title: 'Arcadis Digital Twins',
    logo: {
      light: logoBlack,
      dark: logoWhite,
      width: 200
    }
  },
  {
    hostNamePrefixes: ['nexus', 'waterfinder'],
    title: 'Climate Risk Nexus',
    logo: {
      light: logoNexus,
      dark: logoNexus,
      width: 200
    }
  }
]

export const findCustomPageMeta = (hostname: string) =>
  customPageMeta.find((cp) =>
    cp.hostNamePrefixes.some((prefix) => hostname?.toLocaleLowerCase().includes(prefix))
  ) || customPageMeta[0]
